import React, { useContext } from "react";
import ApplicationFallback from "../applicationFallback/ApplicationFallback";
import { IAccountStatusContext } from "../../types/accountStatus";
import { AccountStatusContext } from "../../context/accountStatusContext";
import AccountBlocked from "../accountBlocked/AccountBlocked";

type Props = {
    children: React.ReactElement<any, any>
}

const AccountStatusVerifier: React.FC<Props> = ({
    children
}) => {

    const {
        isAccountBlocked,
        loading,
    } = useContext(AccountStatusContext) as IAccountStatusContext;

    return (

        <>
            {
                loading &&
                <ApplicationFallback />
            }

            {
                loading === false &&
                <>
                    {
                        isAccountBlocked === false &&
                        <>
                            {children}
                        </>
                    }

                    {
                        isAccountBlocked === true &&
                        <AccountBlocked />
                    }
                </>
            }
        </>
    );
}

export default AccountStatusVerifier;